module.exports = __webpack_public_path__ + "static/media/blinds-open.91babb23.svg";